import { type FC } from 'react'
import { Outlet, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { ProgressSteps } from 'shared/ui/ProgressSteps'
import { AgentNewTestButton, DialogLayout, RootLayout } from 'pages/chatbot/ui'
import { AgentNewDialog } from 'pages/chatbot/ui/ChatbotDialog/AgentDialog/DialogWrapper'
import { DialogEmpty } from 'pages/chatbot/ui/ChatbotDialog/DialogEmpty'
import styles from './styles.module.scss'

type IStepsCommonLayoutProps = {
  progressTitle: string
  totalSteps: number
  settingsStep: number
}

export const StepsCommonLayout: FC<IStepsCommonLayoutProps> = observer(
  ({ progressTitle, settingsStep, totalSteps }) => {
    const { agentId } = useParams()

    return (
      <RootLayout>
        <div className={styles.content}>
          <div className={styles.content__sub}>
            <div className={styles.localProgress}>
              <ProgressSteps title={progressTitle} total={totalSteps} step={settingsStep} />
            </div>
            <div className={styles.section}>
              <Outlet />
            </div>
          </div>
        </div>
        {agentId ? (
          <AgentNewDialog />
        ) : (
          <DialogLayout>
            <DialogEmpty buttonComponent={<AgentNewTestButton />} />
          </DialogLayout>
        )}
      </RootLayout>
    )
  }
)
